(function() {
  'use strict';

  function initSection(section) {
    if (!section || section.dataset.apexTabsInitialized === 'true') return;
    section.dataset.apexTabsInitialized = 'true';

    var tabs = section.querySelectorAll('.advanced-tabbed-section__tab');
    var contents = section.querySelectorAll('.advanced-tabbed-section__content');

    function deactivate() {
      tabs.forEach(function(tab) {
        tab.classList.remove('active');
        tab.setAttribute('aria-selected', 'false');
      });
      contents.forEach(function(content) {
        content.style.display = 'none';
      });
    }

    function activate(tab) {
      if (!tab) return;
      var id = tab.getAttribute('data-tab-target');
      var target = section.querySelector('[data-tab-id="' + id + '"]');
      if (!target) return;

      deactivate();
      tab.classList.add('active');
      tab.setAttribute('aria-selected', 'true');
      target.style.display = 'block';

      var swiperEl = target.querySelector('.advanced-tabbed-section__swiper');
      if (swiperEl && swiperEl.swiper && typeof swiperEl.swiper.update === 'function') {
        swiperEl.swiper.update();
      }
    }

    tabs.forEach(function(tab) {
      tab.addEventListener('click', function() { activate(tab); });
    });
    activate(tabs[0]);

    if (typeof window.Swiper !== 'function') {
      console.warn('[Apex tabs] Swiper failed to load; tab content remains usable without the carousel.');
      return;
    }

    section.querySelectorAll('.advanced-tabbed-section__swiper').forEach(function(swiperEl) {
      if (swiperEl.swiper) return;
      var desktop = parseInt(swiperEl.getAttribute('data-items-per-view'), 10) || 3;
      var tablet = parseInt(swiperEl.getAttribute('data-items-per-view-tablet'), 10) || 2;
      var mobile = parseInt(swiperEl.getAttribute('data-items-per-view-mobile'), 10) || 1;

      new window.Swiper(swiperEl, {
        slidesPerView: desktop,
        spaceBetween: 24,
        navigation: {
          nextEl: swiperEl.querySelector('.swiper-button-next'),
          prevEl: swiperEl.querySelector('.swiper-button-prev')
        },
        pagination: {
          el: swiperEl.querySelector('.swiper-pagination'),
          clickable: true
        },
        breakpoints: {
          0: { slidesPerView: mobile },
          600: { slidesPerView: tablet },
          992: { slidesPerView: desktop }
        }
      });
    });
  }

  function initWithin(rootNode) {
    if (!rootNode) return;
    if (rootNode.matches && rootNode.matches('.advanced-tabbed-section')) initSection(rootNode);
    rootNode.querySelectorAll('.advanced-tabbed-section').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { initWithin(document); });
  } else {
    initWithin(document);
  }

  document.addEventListener('shopify:section:load', function(event) {
    initWithin(event.target);
  });
})();
